//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SpecialistCard from "~/components/zapis/ZapisSpecialistCard.vue";

export default {
  name: 'ZapisSpecialistsCardsList',

  props: {
    selectedSpecialistId: {},
    selectedAge: {},
    selectedSalon: {},
    selectedService: {},
  },

  emits: [
    'change'
  ],

  data: function () {
    return {
      specialistsList: [],

      isLoading: true,
      isOpenSpecialistPopup: false,
      windowWidth: null,
      isShowAllSpecialist: false,
    }
  },

  components: {
    SpecialistCard,
  },

  mounted: async function() {
    await this.getOptions();
    window.addEventListener('resize', this.handleWindowSize);
    this.handleWindowSize();
  },
  unMounted: function () {
    window.removeEventListener('resize', this.handleWindowSize);
  },

  computed: {
    isMobile: function () {
      if (!process.client) {
        return false
      }
      return this.windowWidth < 991
    },
    prepareSpecialistList: function () {
      let list = this.specialistsList;
      if (this.isMobile && !this.isShowAllSpecialist) {
        return list.slice(0,4);
      }
      return list
    }
  },

  methods: {
    getOptions: async function () {
      const filterAge = Boolean(this.selectedAge === "19") ? "filter[for_not_children]=1" : `filter[for_children_${(this.selectedAge || "").replace("-", "_")}]=1`;
      const search = `${ filterAge }&filter[service_id]=${this.selectedService}${ Boolean(String(this.selectedSalon) === "-1") ? '' : `&filter[store_id]=${this.selectedSalon}` }`;
      const action = Boolean(String(this.selectedSalon) === "-1") ? '/specialist' : '/specialist/available';

      let specialistsList = await this.$api.agent.transport.get(`${ action }?expand=stores&${ search }`)
        .then((res) => res?.data || [])
        .catch(() => []);
      this.specialistsList = [
        {name: "Любой специалист", id: -1},
        ...specialistsList
      ];
      this.isLoading = false;
    },
    changeCard: function(specialist) {
      this.$emit('change', specialist)
    },
    handleWindowSize: function () {
      this.windowWidth = window.innerWidth;
    },
    toggleShowSpecialists: function () {
      this.isShowAllSpecialist = !this.isShowAllSpecialist;
    }
  }
}
